import { Box, Sheet, Typography, Chip } from "@mui/joy";

const fmt = (n) => (n ?? 0).toLocaleString("ru-RU");
const unitLabel = (u) => (u === "orders" ? "заказы" : "книги");

export default function FunnelChart({ stages }) {
  if (!stages || !stages.length) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {stages.map((s, i) => {
        // Ширина «ступеньки» пропорциональна доле от старта (минимум для читаемости)
        const width = Math.max(s.pct_of_top ?? 0, 8);
        const opacity = 0.55 + 0.45 * (1 - i / stages.length);
        return (
          <Box key={s.key} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Sheet
              variant="solid"
              color="primary"
              sx={{
                width: `${width}%`, minWidth: 200, borderRadius: "10px",
                px: 2, py: 1.25, textAlign: "center",
                transition: "width .35s ease", opacity,
              }}
            >
              <Typography level="title-sm" sx={{ color: "#fff" }}>{s.label}</Typography>
              <Typography level="h4" sx={{ color: "#fff", lineHeight: 1.15 }}>
                {fmt(s.count)}{" "}
                <Typography level="body-xs" sx={{ color: "rgba(255,255,255,.85)" }}>
                  {unitLabel(s.unit)}
                </Typography>
              </Typography>
              <Box sx={{ display: "flex", gap: 1, justifyContent: "center", mt: 0.5, flexWrap: "wrap" }}>
                <Chip size="sm" variant="soft" color="neutral">{s.pct_of_top}% от старта</Chip>
                {i > 0 && s.pct_of_prev != null && (
                  <Chip size="sm" variant="soft" color="neutral">конверсия {s.pct_of_prev}%</Chip>
                )}
              </Box>
            </Sheet>

            {(s.sub || []).map((sub) => (
              <Typography key={sub.key} level="body-xs" color="neutral" sx={{ mt: 0.25 }}>
                {sub.label}: {fmt(sub.count)}
              </Typography>
            ))}
          </Box>
        );
      })}
    </Box>
  );
}